import { LazyOutlet } from 'design-system/atoms/spinner-suspense';
import { createContext, useMemo, useContext } from 'react';
import { useParams } from 'react-router';

export interface ProjectContextType {
  projectId?: string;
}

export const ProjectContext = createContext<ProjectContextType>({});

export function useProjectContext(): ProjectContextType {
  const context = useContext(ProjectContext);
  if (context === null) {
    throw new Error('Trying to use ProjectContext outside of its provider');
  }
  return context;
}

export default function ContextProject() {
  const { projectId } = useParams();
  const contextValue = useMemo(() => ({ projectId }), [projectId]);
  return (
    <ProjectContext.Provider value={contextValue}>
      <LazyOutlet />
    </ProjectContext.Provider>
  );
}
